import LoginResponse from 'communication/LoginResponse';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyError = any;

export type UserDetails = Omit<LoginResponse, 'featureToggles'>;

export enum LoginStatus {
    NONE = 'NONE',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}

export enum LoginErrorType {
    USER_ACTION_ERROR = 'USER_ACTION_ERROR',
    USER_CONFIGURATION_ERROR = 'USER_CONFIGURATION_ERROR',
    SYSTEM_ERROR = 'SYSTEM_ERROR',
    LOST_NETWORK_CONNECTION = 'LOST_NETWORK_CONNECTION',
}

export interface LoginErrorState {
    type: LoginErrorType;
    title?: string;
    message: string;
    innerError: AnyError;
}

export interface LoginState {
    status: LoginStatus;
    error?: LoginErrorState;
    result?: UserDetails;
}

export const initialLoginState = {
    status: LoginStatus.NONE,
};

export const lostNetworkConnectionLoginErrorState: LoginErrorState = {
    type: LoginErrorType.LOST_NETWORK_CONNECTION,
    message:
        "You've been logged out due to inactivity.  Please login again to refresh.",
    innerError: undefined,
};
